import React from 'react';

function CatalogueGrid({ items, renderItem }) {
  // Use familia-grid class for familias, default for subfamilias/products
  const isFamilia = items.length > 0 && items[0].subfamiliaCount !== undefined;
  return (
    <div className={`catalogue-list${isFamilia ? ' familia-grid' : ''}`}>
      {items.map(renderItem)}
    </div>
  );
}

export default CatalogueGrid;
